export default function scrollToElement(
  target,
  offset = 80,
  behavior = "smooth"
) {
  const element = document.getElementById(target);
  const bodyRect = document.body.getBoundingClientRect().top;
  const elementRect = element.getBoundingClientRect().top;
  const elementPosition = elementRect - bodyRect;
  const offsetPosition = elementPosition - offset;
  window.scrollTo({
    top: offsetPosition,
    behavior,
  });
}
